module.exports = __webpack_public_path__ + "img/25-Emotion.9f5494d7.png";